<template>
    <VJoyWrapper justify="space-between" no-margin>
        <QualificationField
            :title="$t('profile.vetting.community.community_manager.title')"
            data-testid="admin-section-tabs-qualification-community-manager-fullname"
        >
            <p>{{ qualification.communityMetadata?.communityManager?.fullName ?? '-' }}</p>
        </QualificationField>
        <QualificationField
            :title="$t('profile.vetting.community.engagement_status.title')"
            data-testid="admin-section-tabs-qualification-engagement-status"
        >
            <p>{{ qualification.communityMetadata?.engagementStatus ?? '-' }}</p>
        </QualificationField>
        <QualificationField
            :title="$t('profile.vetting.community.onboarding_status.title')"
            data-testid="admin-section-tabs-qualification-onboarding-status"
        >
            <p>{{ qualification.communityMetadata?.onboardingStatus ?? '-' }}</p>
        </QualificationField>
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyWrapper} from '@maltjoy/core-vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();
    const {qualification} = storeToRefs(profileQualificationStore);
</script>
